import client, { fileDownloadClient } from "../http-clients/api";
import type {
    IEventCreateRequest,
    IEventCreateResponse,
    IChangeEventCardRequest,
    IChangeEventRegistryRequest,
    IEventCardTemplate,
    IEventEditRequest,
    IEventListItem,
    IEventSelectItem,
    IEventDetailsResponse,
} from "@types";
import gate from "../gate";

const eventsApi = {
    create: (data: IEventCreateRequest) =>
        gate.post<number | null, IEventCreateRequest, never>({
            client,
            url: "user/event",
            data,
        }),

    changeEventCard: (data: IChangeEventCardRequest) =>
        gate.post<any, IChangeEventCardRequest, never>({
            client,
            url: "user/event/changeEventCard",
            data,
        }),

    changeEventRegistry: (data: IChangeEventRegistryRequest) =>
        gate.post<any, IChangeEventRegistryRequest, never>({
            client,
            url: "user/event/changeEventRegistry",
            data,
        }),

    getCardTemplates: (event_id: number) =>
        gate.get<IEventCardTemplate[], { event_id: number }, never>({
            client,
            url: "user/event/card-templates",
            data: { event_id },
        }),

    edit: (event_id: number, data: IEventEditRequest) =>
        gate.post<any, IEventEditRequest, never>({
            client,
            url: `user/event/${event_id}/edit`,
            data,
        }),

    list: () =>
        gate.get<IEventListItem[], never, never>({
            client,
            url: "user/event",
        }),

    getEventList: (registryId?: number) =>
        gate.get<IEventSelectItem[], never, { registry_id?: number }>({
            client,
            url: "user/event/eventList",
            params: registryId ? { registry_id: registryId } : undefined,
        }),

    getDetails: (id: number) =>
        gate.get<IEventDetailsResponse, { id: number }, never>({
            client,
            url: `user/event/${id}`,
        }),

    delete: (event_id: number) =>
        gate.post<any, never, never>({
            client,
            url: `user/event/${event_id}/delete`,
        }),
};

export default eventsApi; 